import "./LatestClinicalParametersSection.scss";
import {
  ArrowLink,
  LatestCardClinicalData,
  SectionHeading,
} from "@/components";
import { ElementType } from "react";

export type LatestClinicalParameter = {
  categoryLabel: string;
  effectiveTime?: string;
  entity: string;
  device?: string | null;
  value?: number | null;
  measurementUnit?: string;
  variationValue?: string;
  variationUnit?: string;
  variationStatus?: "normal" | "alert";
};

export type LatestClinicalParametersSectionProps = {
  sectionId?: string;
  title?: string;
  linkHref?: string;
  linkLabel?: string;
  asLink?: ElementType;
  parameters?: LatestClinicalParameter[];
};

export const LatestClinicalParametersSection = ({
  sectionId,
  title = "Ultimi parametri rilevati",
  linkHref,
  linkLabel = "Scopri tutti",
  asLink = "a",
  parameters = [],
}: LatestClinicalParametersSectionProps) => {
  const titleId = sectionId ? `${sectionId}-title` : undefined;
  const visibleParameters = parameters?.slice(0, 3) ?? [];

  return (
    <section
      id={sectionId}
      aria-labelledby={titleId}
      className="latest-clinical-parameters section-gap flex-column"
    >
      <SectionHeading
        color={"slate-20"}
        title={title}
        titleId={titleId}
        className="latest-clinical-parameters-heading"
        mdFs="2"
        fs="4"
        titleMarginBottom="mb-x12"
        descriptionMarginBottom="mb-x0"
      >
        {linkHref && (
          <ArrowLink href={linkHref} asLink={asLink} fs="7">
            {linkLabel.toUpperCase()}
          </ArrowLink>
        )}
      </SectionHeading>
      <div className="latest-clinical-parameters-grid" role="list">
        {visibleParameters.map((parameter, index) => (
          <div
            role="listitem"
            key={index}
            className="latest-clinical-parameters-grid-item"
          >
            <LatestCardClinicalData {...parameter} />
          </div>
        ))}
      </div>
    </section>
  );
};
